import React from "react"

import { Wrapper, Row, ColWithBg, Content } from "../pageElements"

export const Clients = () => {
  return (
    <Wrapper>
      <Row height={20}>
        <ColWithBg>
          <Content center>CLIENTS</Content>
        </ColWithBg>
      </Row>
    </Wrapper>
  )
}
